export default "__VITE_ASSET__C6GlCEUf__"